import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { PageFooterHeader } from "@repo/ui/types/cms/common";

export interface KontentState {
  header: PageFooterHeader["header"] | null;
  footer: PageFooterHeader["footer"] | null;
  selectedCulture: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: KontentState = {
  header: null,
  footer: null,
  selectedCulture: null, // Will be updated in an effect
  loading: false,
  error: null,
};

const kontentSlice = createSlice({
  name: "kontent",
  initialState,
  reducers: {
    setSelectedCulture: (state, action: PayloadAction<string>) => {
      const newCulture = action.payload;
      state.selectedCulture = newCulture;
    },
    clearKontent: (state) => {
      state.header = null;
      state.footer = null;
    },
  },
});

// Export actions
export const { clearKontent, setSelectedCulture } = kontentSlice.actions;

// Selectors
type RootState = {
  kontent: KontentState;
};

export const selectHeader = (state: RootState) => state.kontent.header;
export const selectFooter = (state: RootState) => state.kontent.footer;
export const selectSelectedCulture = (state: RootState) => state.kontent.selectedCulture;
export const selectKontentLoading = (state: RootState) => state.kontent.loading;
export const selectKontentError = (state: RootState) => state.kontent.error;

export default kontentSlice.reducer;
